import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthStore } from "../store/authStore";

export default function SuperAdminGuard({ children }) {
  const { user, isInitialized, token } = useAuthStore();
  const location = useLocation();

  // Still loading auth state
  if (!isInitialized && !user) {

    console.log({isInitialized})
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-indigo-600 mx-auto mb-3" />
          <p className="text-sm text-slate-500">Checking admin access...</p>
        </div>
      </div>
    );
  }

  // Not authenticated → login
  if (!token || !user) {
    console.log({token}, {user} )

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Not super admin → dashboard
  if (!user.isSuperAdmin) {
    
    return <Navigate to="/dashboard" replace />;
  }

  // Authorized
  return <Outlet/>;
}